<script setup>
import { RouterLink, RouterView } from 'vue-router'
import { defineComponent } from 'vue'
</script>

<script>
import Config from './config'
import { useQuestStore } from '@/stores'
import { useVersionStore } from '@/stores'
import {
  EventBus,
  FetchWrapper,
  QuestHelpers,
  Utils
} from './lib'

import Modal from './components/ModalComponent.vue'
import LoadingComponent from './components/LoadingComponent.vue'
import logoUrl from '@/assets/images/logo.png'
export default defineComponent({
  data() {
    return {
      version: 'version',
      logoUrl: logoUrl,
      appModalParams: {
          modalOptions: {}
      },
    }
  },
  components: {
    Modal,
    LoadingComponent
  },
  mounted() {
    const self = this

    // Non-block async call to fetch version
    const { getVersion } = useVersionStore()
    getVersion(this).then((version) => {
      self.version = version
    })

    EventBus.$on('showModal', (modalOptions) => {
        this.appModalParams.modalOptions = modalOptions
        this.$refs.appModal.show()
    })
    EventBus.$on('hideModal', () => {
        this.$refs.appModal.hide()
    })
    EventBus.$on('openConfirmDuplicateQuest', (questId) => {
        this.openConfirmDuplicateQuest(questId)
    })
  },
  unmounted(){
    EventBus.$off('showModal')
    EventBus.$off('hideModal')
    EventBus.$off('openConfirmDuplicateQuest')
  },
  methods: {
    async routeTo(route) {
      await this.$router.push(route)
      await this.$router.replace(route)
    },
    openConfirmDuplicateQuest(questId) {
      const self = this
      const modalOptions = {
          property: 'generic',
          id: questId,
          title: `Duplicate Quest ${questId}`,
          body: 'Are you sure you want to duplicate this quest?',
          ctaText: 'Duplicate Quest',
          ctaButtonClass: 'btn btn-primary'
      }
      modalOptions.callback = async function () {
          EventBus.$emit('showQuestLoader')

          const { getQuestByIdAsync } = useQuestStore()
          let duplicateQuest = await getQuestByIdAsync(this, questId)
          duplicateQuest = QuestHelpers.stripExtraneousFields(duplicateQuest)
          delete duplicateQuest.quest_id

          for (let locale in duplicateQuest.title) {
              duplicateQuest.title[locale] = duplicateQuest.title[locale] + ' (Copy)'
          }
          for (let locale in duplicateQuest.description) {
              duplicateQuest.description[locale] = duplicateQuest.description[locale] + ' (Copy)'
          }

          return FetchWrapper.post(`${Config.BASE_URL}/quest`, duplicateQuest)
          .then(async (quest) => {
              const questId = quest.quest_id
              // Trigger a refresh of the quest list
              await self.$router.push('/quests/')
              await self.$router.push(`/quests/${questId}`)
              self.$notify({
                  title: 'Quest Duplicated',
                  text: `Quest ${questId} successfully duplicated`,
                  type: 'success'
              })

              await QuestHelpers.getSourceQuests(true)
              await QuestHelpers.getTargetQuests(true)

              EventBus.$emit('hideQuestLoader')
          }).catch(error => {
              Utils.notifyError(self, error)
              return Promise.reject(error)
          })
      }
      EventBus.$emit('showModal', modalOptions)
    }
  }
})
</script>

<template>
  <div>

    <Modal ref="appModal" v-bind="appModalParams" />

    <notifications position="bottom right" />

    <div id="eco-ui" class="eco-ui" style="display: block;">
      <div class="eco-ui-content">
        <div id="eco-ui-header" class="eco-ui-header">
          <div class="eco-ui-header-logo">
              <img :src="logoUrl"
                  class="eco-ui-tooltip"
                  v-tooltip.bottom="version" />
          </div>
          <div>XPromo2 Admin</div>
        </div>

        <div class="eco-ui-content-inner">
          <ul class="nav nav-tabs mb-2">
            <li class="nav-item">
              <RouterLink to="/getting-started"
                  @click="$router.push('/getting-started')"
                  class="nav-link"
                  name="getting-started"
                  active-class="active">
                Getting Started
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/titles"
                  @click="$router.push('/titles')"
                  class="nav-link"
                  name="titles"
                  :class="{'nav-link active': $route.path.indexOf('/title') > -1 }">
                Titles
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/quests"
                  @click="routeTo('/quests')"
                  class="nav-link"
                  name="quests"
                  :class="
                    {'nav-link active':
                    (
                      $route.path.indexOf('/quests') > -1 &&
                      $route.path.indexOf('/quests/targeted') === -1
                    )
                    }
                  ">
                  Quests
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/quests/targeted"
                  @click="routeTo('/quests/targeted')"
                  class="nav-link"
                  name="targeted-quests"
                  :class="{'nav-link active': $route.path.indexOf('/quests/targeted') > -1 }">
                  Targeted Quests
              </RouterLink>
            </li>
          </ul>

          <RouterView />

          <LoadingComponent />

        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
</style>